<template>
  <ChatBotSmoochCL
    :is-in-store-device="true"
    :chat-bot-metadata="chatBotMetada"
    :initialize-chat-bot="true"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ChatBotSmoochCL from "@/apps/credit-line/components/ChatBotSmoochCL.vue";
import { localStoragePersonUuidKey } from "@/apps/core-app-onboarding/store/core-app-onboarding.module";
import { AndroidInterface } from "@/apps/core-app-onboarding/services/android.service";
// IMPORTAT: Shared dependecies. Might need to refactor to reduce build size during code-split project
import { getLanguageName } from "@/shared-helpers/language.helper";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "ChatbotWrapper",
  components: {
    ChatBotSmoochCL,
  },
  setup() {
    const personUuid = localStorage.getItem(
      localStoragePersonUuidKey
    ) as string;
    const applicationId = Android.getCreditLineApplicationId();
    const chatBotMetada = {
      product: "CL",
      userType: "customer",
      registrationTag: null,
      personUuid: personUuid,
      name: null,
      applicationId: applicationId,
      deviceId: null,
      creditLineId: null,
      // ToDO: Retrieve country from state or API call
      country: "MX",
      language: getLanguageName(),
    };

    return {
      chatBotMetada,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
